"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  AddNewPaymentForm: () => AddNewPaymentForm,
  Button: () => Button,
  CheckBox: () => CheckBox,
  ConfirmModal: () => ConfirmModal,
  Cypher: () => Cypher,
  CypherRating: () => CypherRating,
  Cyphers: () => Cyphers,
  ECathegory: () => ECathegory,
  ECypherType: () => ECypherType,
  EHelpType: () => EHelpType,
  EMessageType: () => EMessageType,
  EPage: () => EPage,
  EUserType: () => EUserType,
  Footer: () => Footer,
  ForumForm: () => ForumForm,
  ForumMessage: () => ForumMessage,
  Header: () => Header,
  Heading: () => Heading,
  Help: () => Help,
  Input: () => Input,
  Loading: () => Loading,
  LoadingPage: () => LoadingPage,
  LoginModal: () => LoginModal,
  Modal: () => Modal,
  PaymentSection: () => PaymentSection,
  Pdf: () => Pdf,
  Player: () => Player,
  QrPayment: () => QrPayment,
  ScrollToTop: () => ScrollToTop,
  Section: () => Section,
  Select: () => Select,
  Spacer: () => Spacer,
  Team: () => Team,
  UserModal: () => UserModal,
  addPayment: () => addPayment,
  configureApi: () => configureApi,
  createAppRedux: () => createAppRedux,
  del: () => del,
  deleteCookie: () => deleteCookie,
  deletePayment: () => deletePayment,
  deletePlayerEmail: () => deletePlayerEmail,
  generateCzechSpd: () => generateCzechSpd,
  generateNewLoginToken: () => generateNewLoginToken,
  get: () => get,
  getAdminTeams: () => getAdminTeams,
  getCookie: () => getCookie,
  getCypherMessages: () => getCypherMessages,
  getForumMessages: () => getForumMessages,
  getId: () => getId,
  getStars: () => getStars,
  getStats: () => getStats,
  getTeams: () => getTeams,
  getUser: () => getUser,
  getUserDetail: () => getUserDetail,
  hash: () => hash,
  isValidEmail: () => isValidEmail,
  isValidFullName: () => isValidFullName,
  isValidPhone: () => isValidPhone,
  isValidPlayer: () => isValidPlayer,
  loginUser: () => loginUser,
  notEmptyString: () => notEmptyString,
  post: () => post,
  reUnregisterTeam: () => reUnregisterTeam,
  registerUser: () => registerUser,
  saveForumMessage: () => saveForumMessage,
  saveUser: () => saveUser,
  sendForgottenPassword: () => sendForgottenPassword,
  setCookie: () => setCookie,
  setStars: () => setStars,
  unregisterTeam: () => unregisterTeam,
  useOnClickOutside: () => useOnClickOutside
});
module.exports = __toCommonJS(index_exports);

// src/api/axiosClient.ts
var local = "http://localhost:53471//api/";
var production = "https://www.sifrovacihra.cz/api/";
var host = window.location.href.includes("localhost") ? local : production;
var actualGame = "";
var axiosInstance = null;
var configureApi = (game, axios) => {
  actualGame = game;
  axiosInstance = axios;
};
var post = async ({ data, params, path, token, game }) => {
  const config = {
    params,
    headers: {
      "Game": game ? game : actualGame,
      "Auth": token,
      "Content-Type": "application/json"
    }
  };
  return await axiosInstance.post(host + path, data, config).then((res) => {
    if (res) {
      return { status: res.status, data: res.data };
    }
    return { status: 400, data: void 0 };
  }).catch((e) => {
    var _a, _b;
    console.log(e);
    return { status: (_a = e.response) == null ? void 0 : _a.status, data: (_b = e.response) == null ? void 0 : _b.data };
  });
};
var del = async ({ data, params, path, token, game }) => {
  const config = {
    params,
    headers: {
      "Game": game ? game : actualGame,
      "Auth": token,
      "Content-Type": "application/json"
    },
    data
  };
  return await axiosInstance.delete(host + path, config).then((res) => {
    if (res) {
      return { status: res.status, data: res.data };
    }
    return { status: 400, data: void 0 };
  }).catch((e) => {
    var _a, _b;
    console.log(e);
    return { status: (_a = e.response) == null ? void 0 : _a.status, data: (_b = e.response) == null ? void 0 : _b.data };
  });
};
var get = async ({ params, path, token, game }) => {
  const config = {
    params,
    headers: {
      "Game": game ? game : actualGame,
      "Auth": token
    }
  };
  return await axiosInstance.get(host + path, config).then((res) => {
    if (res) {
      return { status: res.status, data: res.data };
    }
    return { status: 400, data: void 0 };
  }).catch((e) => {
    var _a, _b;
    console.log(e);
    return { status: (_a = e.response) == null ? void 0 : _a.status, data: (_b = e.response) == null ? void 0 : _b.data };
  });
};

// src/api/admin.ts
var addPayment = async ({ idTeam, token }) => {
  return await post({
    data: {},
    params: { teamId: idTeam, newPayment: true },
    path: "admin/teams/payment",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};
var deletePayment = async ({ idTeam, token }) => {
  return await post({
    data: {},
    params: { teamId: idTeam, newPayment: false },
    path: "admin/teams/payment",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};
var unregisterTeam = async ({ idTeam, token }) => {
  return await post({
    data: {},
    params: { teamId: idTeam, cancel: true },
    path: "admin/teams/registtation",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};
var reUnregisterTeam = async ({ idTeam, token }) => {
  return await post({
    data: {},
    params: { teamId: idTeam, cancel: false },
    path: "admin/teams/registtation",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};
var deletePlayerEmail = async ({ email, token }) => {
  return await del({
    data: { email },
    path: "admin/gdpr/email",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};
var getAdminTeams = async ({ token }) => {
  return await get({
    params: {},
    path: "admin/teams",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { teams: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};

// src/api/cypher.ts
var getStars = async ({ cypherId, token }) => {
  return await get({
    params: { cypherId },
    path: "websystem/cypher/stars",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { stars: res.data.stars, teamStars: res.data.teamStars, votes: res.data.votes };
    } else {
      return { errorMessage: res.data };
    }
  });
};
var setStars = async ({ cypherId, token, stars }) => {
  return await post({
    data: {},
    params: { cypherId, stars },
    path: "websystem/cypher/stars",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { stars: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};
var getCypherMessages = async () => {
  return await get({
    params: {},
    path: "forum"
  }).then((res) => {
    if (res.status === 200) {
      return { messages: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};

// src/api/forum.ts
var saveForumMessage = async ({ message, forum, endpoint = "forum", token }) => {
  return await post({
    data: JSON.stringify(message),
    params: { forum },
    path: endpoint,
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};
var getForumMessages = async ({ forum, game }) => {
  return await get({
    params: { forum, game },
    path: "forum"
  }).then((res) => {
    if (res.status === 200) {
      return { messages: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};

// src/api/login.ts
var getId = async ({ login }) => {
  return await get({
    params: { name: login },
    path: "login"
  }).then((res) => {
    if (res.status === 200) {
      return res.data;
    } else {
      return "";
    }
  });
};
var loginUser = async ({ login, password }) => {
  return await post({
    data: {},
    params: {
      name: login,
      password
    },
    path: "login"
  }).then((res) => {
    if (res.status === 200) {
      return { token: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};
var generateNewLoginToken = async ({ id, token }) => {
  return await post({
    data: {},
    params: { idTeam: id },
    path: "login/newCode",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { token: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};
var sendForgottenPassword = async ({ login, email }) => {
  return await post({
    data: {},
    params: {
      name: login,
      email
    },
    path: "login/password"
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else if (res.status === 401) {
      return { errorMessage: "Jm\xE9no t\xFDmu nebo email hr\xE1\u010De nesed\xED." };
    } else {
      return { errorMessage: "Obnova hesla se nezda\u0159ila, kontaktujte pros\xEDm organiz\xE1tory emailem." };
    }
  });
};

// src/api/stats.ts
var getStats = async ({ game, cathegory, token }) => {
  return await get({
    params: cathegory ? { cathegory } : {},
    path: "websystem/stats",
    game,
    token
  }).then((res) => {
    if (res.status === 200) {
      return { stats: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};

// src/api/team.ts
var getTeams = async () => {
  return await get({
    params: {},
    path: "teams"
  }).then((res) => {
    if (res.status === 200) {
      return { teams: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};

// src/api/user.ts
var registerUser = async ({ name }) => {
  return await post({
    data: {},
    params: { name },
    path: "users"
  }).then((res) => {
    if (res.status === 200) {
      return { token: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};
var getUser = async ({ token }) => {
  return await get({
    params: {},
    path: "users",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { user: res.data };
    } else {
      return { errorMessage: res.data, unauthorized: res.status === 401 };
    }
  });
};
var getUserDetail = async ({ token }) => {
  return await get({
    params: { detail: true },
    path: "users",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { user: res.data };
    } else {
      return { errorMessage: res.data };
    }
  });
};
var saveUser = async ({ user, token }) => {
  return await post({
    data: JSON.stringify(user),
    params: {},
    path: "users",
    token
  }).then((res) => {
    if (res.status === 200) {
      return { success: true };
    } else {
      return {
        errorMessage: res.data,
        success: false
      };
    }
  });
};

// src/components/forum/ForumForm.tsx
var import_react = require("react");

// src/components/forms/button/Button.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Button = ({ text, onClick, disabled, secondary, icon }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "sh-button" + (secondary ? " sh-button--secondary" : ""), children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "button",
    {
      className: "sh-button__button" + (secondary ? " sh-button__button--secondary" : ""),
      onClick,
      disabled,
      children: [
        text,
        icon ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "sh-button__icon", children: icon }) : null
      ]
    }
  ) });
};

// src/components/forms/input/Input.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Input = ({ label, required, disabled, errorMessage = "", value, type, setValue }) => {
  const invalid = errorMessage.length > 0;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "sh-input", children: [
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "sh-input__label", children: [
      label,
      required ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: "sh-input__required", children: "*" }) : ""
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "sh-input__field", children: [
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "sh-input__box" + (invalid ? " sh-input__box--invalid" : ""), children: type === "textarea" ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        "textarea",
        {
          className: "sh-input__textarea",
          onChange: setValue,
          value,
          disabled
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        "input",
        {
          className: "sh-input__input",
          type,
          onChange: setValue,
          value,
          disabled
        }
      ) }),
      invalid ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "sh-input__error", children: errorMessage }) : null
    ] })
  ] });
};

// src/components/forum/ForumForm.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var ForumForm = ({
  forum,
  onReload,
  token,
  endpoint = "forum",
  inputLabel = "Jm\xE9no",
  initialAuthor,
  onSuccess,
  onError
}) => {
  const [author, setAuthor] = (0, import_react.useState)("");
  const [authorError, setAuthorError] = (0, import_react.useState)("");
  const [message, setMessage] = (0, import_react.useState)("");
  const [messageError, setMessageError] = (0, import_react.useState)("");
  (0, import_react.useEffect)(() => {
    if (initialAuthor && author.length < 1) {
      setAuthor(initialAuthor);
    }
  }, [initialAuthor]);
  const addMessage = () => {
    setAuthorError("");
    setMessageError("");
    if (author.trim().length < 1) {
      setAuthorError("Vypl\u0148te jm\xE9no autora p\u0159\xEDsp\u011Bvku.");
      return;
    }
    if (message.length < 1) {
      setMessageError("Nelze odeslat pr\xE1zdnou zpr\xE1vu.");
      return;
    }
    saveForumMessage({
      forum,
      message: { Author: author.trim(), Message: message },
      endpoint,
      token
    }).then((res) => {
      if (res.success) {
        setMessage("");
        onReload();
        onSuccess == null ? void 0 : onSuccess("Zpr\xE1va byla ulo\u017Eena.");
      } else {
        onError == null ? void 0 : onError(res.errorMessage || "P\u0159i odes\xEDl\xE1n\xED zpr\xE1vy do\u0161lo k ne\u010Dekan\xE9 chyb\u011B.");
      }
    }).catch(() => {
      onError == null ? void 0 : onError("P\u0159i odes\xEDl\xE1n\xED zpr\xE1vy do\u0161lo k ne\u010Dekan\xE9 chyb\u011B.");
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: "sh-forum-form", children: [
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      Input,
      {
        type: "text",
        label: inputLabel,
        value: author,
        setValue: (e) => {
          setAuthorError("");
          setAuthor(e.target.value);
        },
        required: true,
        errorMessage: authorError
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      Input,
      {
        type: "textarea",
        label: "Zpr\xE1va",
        value: message,
        setValue: (e) => {
          setMessageError("");
          setMessage(e.target.value);
        },
        required: true,
        errorMessage: messageError
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Button, { text: "Odeslat", onClick: addMessage })
  ] });
};

// src/components/forum/ForumMessage.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var ForumMessage = ({ message }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: `sh-forum-message${message.isAdmin ? " sh-forum-message--admin" : ""}`, children: [
    /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "sh-forum-message__headline", children: [
      /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: "sh-forum-message__headline__name", children: [
        message.Headline ? message.Headline : message.Author,
        message.isAdmin && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { className: "sh-forum-message__badge", children: "Organiz\xE1tor" })
      ] }),
      message.Headline && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "sh-forum-message__headline__author", children: message.Author }),
      /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "sh-forum-message__headline__date", children: message.Date })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "sh-forum-message__body", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("p", { style: { whiteSpace: "pre-wrap" }, children: message.Message }) })
  ] });
};

// src/components/footer/Footer.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var Footer = ({ items, className }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("footer", { className: className ? `sh-footer ${className}` : "sh-footer", children: items.map((item) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    "a",
    {
      href: item.href,
      target: "_blank",
      rel: "noreferrer",
      className: "sh-footer__link",
      children: item.logo ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "sh-footer__logo", children: item.logo }) : /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("span", { className: "sh-footer__item", children: [
        item.icon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "sh-footer__item__icon", children: item.icon }),
        item.text != null && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "sh-footer__item__text", children: item.text })
      ] })
    },
    item.key
  )) });
};

// src/components/forms/adminPayments/AddNewPaymentForm.tsx
var import_react2 = require("react");
var import_jsx_runtime6 = require("react/jsx-runtime");
var AddNewPaymentForm = ({
  teams,
  title = "Zadat novou platbu",
  variableSymbolPrefix,
  variableSymbol,
  onVariableSymbolChange,
  setError,
  setSuccess,
  addPayment: addPayment2,
  token,
  loadTeams,
  ButtonComponent,
  TextInputComponent
}) => {
  const [vsError, setVsError] = (0, import_react2.useState)("");
  const [selectedAddPaymentTeam, setSelectedAddPaymentTeam] = (0, import_react2.useState)();
  const normalizedVs = variableSymbol.replace(/\s/g, "");
  (0, import_react2.useEffect)(() => {
    let regex = /^\d+$/;
    if (normalizedVs.length === 8 && normalizedVs.startsWith(variableSymbolPrefix) && regex.test(normalizedVs)) {
      let id = Number(normalizedVs.slice(-4));
      setSelectedAddPaymentTeam(teams == null ? void 0 : teams.find((t) => t.Id === id));
    } else {
      setSelectedAddPaymentTeam(void 0);
    }
  }, [normalizedVs, teams, variableSymbolPrefix]);
  const setPayment = () => {
    setError("");
    setSuccess("");
    let regex = /^\d+$/;
    if (normalizedVs.length !== 8 || !normalizedVs.startsWith(variableSymbolPrefix) || !regex.test(normalizedVs)) {
      setVsError("Toto nen\xED variabiln\xED symbol!");
      return;
    }
    let id = Number(normalizedVs.slice(-4));
    let team = teams == null ? void 0 : teams.find((t) => t.Id === id);
    if (!team) {
      setVsError("T\xFDm s t\xEDmto variabiln\xEDm symbolem neexistuje!");
      return;
    }
    if (team.Payed) {
      setVsError("T\xFDm m\xE1 ji\u017E zaplaceno!");
      return;
    }
    addPayment2({ idTeam: id, token }).then((res) => {
      if (res.success) {
        setSuccess("Platba byla zad\xE1na!");
      } else if (res.errorMessage) {
        setError(res.errorMessage);
      } else {
        setError("Do\u0161lo k ne\u010Dekan\xE9 chyb\u011B");
      }
      loadTeams();
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_jsx_runtime6.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(Section, { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(import_jsx_runtime6.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(Heading, { headline: title, weight: 3 }),
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
      TextInputComponent,
      {
        label: "Variabiln\xED symbol",
        value: variableSymbol,
        type: "text",
        errorMessage: vsError,
        setValue: (e) => onVariableSymbolChange(e.target.value.replace(/\s/g, ""))
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("p", { children: [
      "Zad\xE1v\xE1te platbu pro t\xFDm: ",
      /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("strong", { children: selectedAddPaymentTeam == null ? void 0 : selectedAddPaymentTeam.Name }),
      (selectedAddPaymentTeam == null ? void 0 : selectedAddPaymentTeam.Payed) && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("span", { style: { color: "red" }, children: "\u26A0" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(ButtonComponent, { text: "Zadat", onClick: setPayment })
  ] }) }) });
};

// src/components/forms/checkbox/CheckBox.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var CheckBox = ({ label, checked, setChecked }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("label", { className: "sh-checkbox", children: [
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      "input",
      {
        type: "checkbox",
        className: "sh-checkbox__input",
        checked,
        onChange: (e) => setChecked(e.target.checked)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "sh-checkbox__checkmark" }),
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "sh-checkbox__label", children: label })
  ] });
};

// src/components/forms/select/Select.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Select = ({ label, options, value, onChange, errorMessage }) => {
  const onSelect = (e) => {
    const option = options.find((o) => o.key.toString() === e.target.value);
    if (option) {
      onChange(option.key);
    }
  };
  const invalid = !!errorMessage && errorMessage.length > 0;
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "sh-select", children: [
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "sh-select__label", children: label }),
    /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "sh-select__field", children: [
      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
        "select",
        {
          className: "sh-select__select" + (invalid ? " sh-select__select--invalid" : ""),
          onChange: onSelect,
          value: value !== void 0 ? value.toString() : "",
          children: options.map((o) => /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("option", { value: o.key.toString(), children: o.label }, o.key.toString()))
        }
      ),
      invalid ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "sh-select__error", children: errorMessage }) : null
    ] })
  ] });
};

// src/components/header/Header.tsx
var import_react5 = require("react");

// ../../node_modules/react-icons/lib/esm/iconBase.js
var import_react4 = __toESM(require("react"));

// ../../node_modules/react-icons/lib/esm/iconContext.js
var import_react3 = __toESM(require("react"));
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = import_react3.default.createContext && import_react3.default.createContext(DefaultContext);

// ../../node_modules/react-icons/lib/esm/iconBase.js
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i) {
    return import_react4.default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return import_react4.default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return import_react4.default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && import_react4.default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? import_react4.default.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// ../../node_modules/react-icons/tb/index.esm.js
function TbMoneybag(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "strokeWidth": "2", "stroke": "currentColor", "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "stroke": "none", "d": "M0 0h24v24H0z", "fill": "none" } }, { "tag": "path", "attr": { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5z" } }, { "tag": "path", "attr": { "d": "M4 17v-1a8 8 0 1 1 16 0v1a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" } }] })(props);
}
function TbUserCircle(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "strokeWidth": "2", "stroke": "currentColor", "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "stroke": "none", "d": "M0 0h24v24H0z", "fill": "none" } }, { "tag": "path", "attr": { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" } }, { "tag": "path", "attr": { "d": "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" } }, { "tag": "path", "attr": { "d": "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" } }] })(props);
}

// src/components/header/Header.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var Item = ({ item, onAfterClick }) => {
  const content = /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_jsx_runtime9.Fragment, { children: [
    item.icon && /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "sh-header__item__icon", children: item.icon }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "sh-header__item__text", children: item.text })
  ] });
  if (item.href) {
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      "a",
      {
        className: "sh-header__item",
        href: item.href,
        onClick: (e) => {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          item.onClick();
          onAfterClick == null ? void 0 : onAfterClick();
        },
        children: content
      }
    );
  }
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    "div",
    {
      className: "sh-header__item",
      onClick: () => {
        item.onClick();
        onAfterClick == null ? void 0 : onAfterClick();
      },
      children: content
    }
  );
};
var Header = ({ logo, items, loginText, onLoginClick, loginIcon, mobileExtraItems, children }) => {
  const [menuOpen, setMenuOpen] = (0, import_react5.useState)(false);
  const closeMenu = () => setMenuOpen(false);
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_jsx_runtime9.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "sh-header", children: [
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "sh-header__logo", children: logo }),
      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("nav", { className: "sh-header__menu", children: items.map((item) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(Item, { item }, item.key)) }),
      /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "sh-header__login", onClick: onLoginClick, children: [
        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "sh-header__login__icon", children: loginIcon != null ? loginIcon : /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(TbUserCircle, { size: 32 }) }),
        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "sh-header__login__text", children: loginText })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
        "div",
        {
          className: menuOpen ? "sh-header__burger open" : "sh-header__burger",
          onClick: () => setMenuOpen(!menuOpen),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", {}),
            /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", {}),
            /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", {})
          ]
        }
      )
    ] }),
    menuOpen && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "sh-header__small-menu", children: [
      items.map((item) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(Item, { item, onAfterClick: closeMenu }, item.key)),
      mobileExtraItems == null ? void 0 : mobileExtraItems.map((item) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(Item, { item, onAfterClick: closeMenu }, item.key))
    ] }),
    children
  ] });
};

// src/components/history/Cypher.tsx
var import_react8 = require("react");

// src/types/components.ts
var EMessageType = /* @__PURE__ */ ((EMessageType2) => {
  EMessageType2["SUCCESS"] = "success";
  EMessageType2["ERROR"] = "error";
  EMessageType2["ALERT"] = "alert";
  return EMessageType2;
})(EMessageType || {});

// src/types/navigation.ts
var EPage = /* @__PURE__ */ ((EPage2) => {
  EPage2["ADMIN"] = "admin";
  EPage2["FORUM"] = "forum";
  EPage2["HISTORY"] = "history";
  EPage2["HOME"] = "home";
  EPage2["REGISTRATION"] = "registration";
  EPage2["RULES"] = "rules";
  EPage2["STATS"] = "stats";
  EPage2["TEAMS"] = "teams";
  return EPage2;
})(EPage || {});

// src/types/game.ts
var ECypherType = /* @__PURE__ */ ((ECypherType2) => {
  ECypherType2["CYPHER"] = "C";
  ECypherType2["FINISH"] = "F";
  ECypherType2["START"] = "S";
  ECypherType2["BONUS"] = "B";
  return ECypherType2;
})(ECypherType || {});
var EHelpType = /* @__PURE__ */ ((EHelpType2) => {
  EHelpType2["NORMAL"] = "N";
  EHelpType2["INSTRUCTION"] = "I";
  EHelpType2["ABSOLUTE"] = "A";
  EHelpType2["MINI"] = "M";
  return EHelpType2;
})(EHelpType || {});

// src/types/user.ts
var ECathegory = /* @__PURE__ */ ((ECathegory2) => {
  ECathegory2["Z"] = "Za\u010D\xE1te\u010Dn\xEDci";
  ECathegory2["P"] = "Pokro\u010Dil\xED";
  return ECathegory2;
})(ECathegory || {});
var EUserType = /* @__PURE__ */ ((EUserType2) => {
  EUserType2[EUserType2["ADMIN"] = 1] = "ADMIN";
  EUserType2[EUserType2["TEAM"] = 0] = "TEAM";
  EUserType2[EUserType2["CANCELLED"] = 2] = "CANCELLED";
  return EUserType2;
})(EUserType || {});

// src/components/loading/Loading.tsx
var import_react_spinners = require("react-spinners");
var import_jsx_runtime10 = require("react/jsx-runtime");
var Loading = ({ size = 50, color = "var(--brand-darker, #cf8746)" }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "loading", children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "loading__spinner", children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    import_react_spinners.MoonLoader,
    {
      color,
      loading: true,
      "aria-label": "Loading Spinner",
      "data-testid": "loader",
      size
    }
  ) }) });
};

// src/components/loading/LoadingPage.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var LoadingPage = ({ size = 60, className = "page" }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(Loading, { size }) });
};

// src/components/pageComponents/heading/Heading.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var Heading = ({ headline, weight, icon, centered }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("div", { className: "sh-headline " + (centered ? "centered" : ""), children: {
    1: /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("h1", { className: "headline1", children: [
      " ",
      icon,
      " ",
      headline
    ] }),
    2: /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("h2", { className: "headline2", children: [
      " ",
      icon,
      " ",
      headline
    ] }),
    3: /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("h3", { className: "headline3", children: [
      " ",
      icon,
      " ",
      headline
    ] }),
    4: /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("h4", { className: "headline4", children: [
      " ",
      icon,
      " ",
      headline
    ] })
  }[weight] });
};

// src/components/pageComponents/section/Section.tsx
var import_jsx_runtime13 = require("react/jsx-runtime");
var Section = ({
  children,
  centered,
  nopadding,
  delimeter
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)(import_jsx_runtime13.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
      "div",
      {
        className: "sh-section" + (centered ? " sh-section--centered" : "") + (nopadding ? " sh-section--nopadding" : ""),
        children
      }
    ),
    delimeter && /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("hr", { className: "sh-section__hr" })
  ] });
};

// src/components/pageComponents/spacer/Spacer.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
var Spacer = ({ size }) => {
  const n = size ? size : 1;
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(import_jsx_runtime14.Fragment, { children: Array.from({ length: n }, (_, i) => /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("div", { className: "spacer" }, i)) });
};

// src/components/pdf/Pdf.tsx
var import_react6 = require("react");
var import_react_pdf = require("react-pdf");
var import_jsx_runtime15 = require("react/jsx-runtime");
var Pdf = ({ url }) => {
  import_react_pdf.pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${import_react_pdf.pdfjs.version}/build/pdf.worker.min.mjs`;
  const [failed, setFailed] = (0, import_react6.useState)(false);
  if (!url || failed) return null;
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "pdf", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(import_react_pdf.Document, { file: url, onLoadError: () => setFailed(true), children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(import_react_pdf.Page, { pageNumber: 1, renderTextLayer: false, renderAnnotationLayer: false }) }) });
};

// src/components/history/Help.tsx
var import_react7 = require("react");
var import_jsx_runtime16 = require("react/jsx-runtime");
var Help = ({ help }) => {
  const [visible, setVisible] = (0, import_react7.useState)(false);
  (0, import_react7.useEffect)(() => {
    setVisible(false);
  }, [help]);
  function helpInfo() {
    switch (help.type) {
      case "A" /* ABSOLUTE */:
        return "\u0159e\u0161en\xED \u0161ifry";
      case "I" /* INSTRUCTION */:
        return "postup \u0159e\u0161en\xED";
      case "N" /* NORMAL */:
        return `${help.order}. n\xE1pov\u011Bdu`;
      case "M" /* MINI */:
        return `\u0159e\u0161en\xED mini \u0161if\u0159i\u010Dky ${help.name}`;
    }
    return "n\xE1pov\u011Bdu";
  }
  if (!help.help) {
    return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(import_jsx_runtime16.Fragment, {});
  }
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("div", { className: "sh-help", children: visible ? /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("div", { className: "sh-help__visible", dangerouslySetInnerHTML: { __html: help.help } }) : /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)("div", { className: "sh-help__hidden", onClick: () => setVisible(true), children: [
    "Zobrazit ",
    helpInfo()
  ] }) });
};

// src/components/history/Cypher.tsx
var import_jsx_runtime17 = require("react/jsx-runtime");
var Cypher = ({ cypher, game, forumKey, token, endpoint, ratingSlot }) => {
  var _a, _b;
  const [loading, setLoading] = (0, import_react8.useState)(true);
  const [messages, setMessages] = (0, import_react8.useState)();
  const [initialAuthor, setInitialAuthor] = (0, import_react8.useState)("");
  (0, import_react8.useEffect)(() => {
    setLoading(true);
    reloadMessages();
  }, [forumKey, game]);
  (0, import_react8.useEffect)(() => {
    if (token && !initialAuthor) {
      getUserDetail({ token }).then((res) => {
        var _a2;
        if ((_a2 = res.user) == null ? void 0 : _a2.Name) {
          setInitialAuthor(res.user.Type === 1 /* ADMIN */ ? res.user.Name : `? (${res.user.Name})`);
        }
      });
    }
  }, [initialAuthor, token]);
  const reloadMessages = () => {
    getForumMessages({
      forum: forumKey,
      game
    }).then((res) => {
      if (!res.errorMessage) {
        setMessages(res.messages);
      }
    }).finally(() => {
      setLoading(false);
    });
  };
  if (!cypher) {
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_jsx_runtime17.Fragment, {});
  }
  const helps = (_a = cypher.helps) != null ? _a : [];
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { className: "sh-cypher", children: [
    /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Heading, { headline: cypher.type === "B" /* BONUS */ ? "Bonus " + cypher.name : "\u0160ifra " + cypher.Id + ": " + cypher.name, weight: 3 }),
    ratingSlot,
    cypher.message ? /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Section, { children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("div", { dangerouslySetInnerHTML: { __html: cypher.message } }) }) : /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_jsx_runtime17.Fragment, {}),
    cypher.url && /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("div", { className: "sh-cypher__pdf", children: /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Pdf, { url: cypher.url }) }),
    /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { className: "sh-cypher__detail", children: [
      cypher.url ? /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { children: [
        "Zad\xE1n\xED si m\u016F\u017Eete st\xE1hnout ",
        /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("a", { href: cypher.url, target: "_blank", rel: "noreferrer", children: "zde" }),
        "."
      ] }) : "",
      helps.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("div", { className: "sh-cypher__helps", children: helps.map((h, i) => /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Help, { help: h }, i)) }) : /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_jsx_runtime17.Fragment, {}),
      ((_b = cypher.solutionUrl) == null ? void 0 : _b.url) ? /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { children: [
        /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("a", { href: cypher.solutionUrl.url, target: "_blank", rel: "noreferrer", children: "\u0158e\u0161en\xED \u0161ifry" }),
        "."
      ] }) : /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_jsx_runtime17.Fragment, {}),
      /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Heading, { headline: "Koment\xE1\u0159e k \u0161if\u0159e", weight: 3 }),
      /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { className: "sh-cypher__comments", children: [
        /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
          ForumForm,
          {
            forum: forumKey,
            onReload: reloadMessages,
            token,
            endpoint,
            initialAuthor
          }
        ),
        loading ? /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(Loading, { size: 60 }) : /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("div", { className: "sh-cypher__messages", children: messages == null ? void 0 : messages.map((m, i) => /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(ForumMessage, { message: m }, i)) })
      ] })
    ] })
  ] });
};

// src/components/history/CypherRating.tsx
var import_Rating = __toESM(require("@mui/material/Rating"));
var import_react9 = require("react");
var import_jsx_runtime18 = require("react/jsx-runtime");
var CypherRating = ({ cypherId, stars, votes, token, interactive }) => {
  const [ratingStars, setRatingStars] = (0, import_react9.useState)(0);
  const [ratingTeamStars, setRatingTeamStars] = (0, import_react9.useState)(0);
  const [ratingVotes, setRatingVotes] = (0, import_react9.useState)(0);
  const [ratingStarsLabel, setRatingStarsLabel] = (0, import_react9.useState)(0);
  (0, import_react9.useEffect)(() => {
    if (stars) {
      setRatingStars(stars);
      setRatingVotes(votes != null ? votes : 0);
    } else {
      refreshRating();
    }
  }, [cypherId]);
  const onRatingChange = (newValue) => {
    if (newValue && token && newValue !== ratingTeamStars) {
      setStars({
        cypherId,
        token,
        stars: newValue
      }).then((res) => {
        if (!res.errorMessage) {
          setRatingStars(newValue);
          refreshRating();
        }
      });
    }
  };
  const refreshRating = () => {
    setRatingStars(0);
    setRatingVotes(0);
    setRatingTeamStars(0);
    getStars({ cypherId, token }).then((res) => {
      if (res.stars) {
        setRatingStars(res.stars);
      }
      if (res.teamStars) {
        setRatingTeamStars(res.teamStars);
      }
      if (res.votes) {
        setRatingVotes(res.votes);
      }
    });
  };
  const onRatingHover = (newValue) => {
    if (newValue && newValue > 0) {
      setRatingStarsLabel(newValue);
    } else {
      setRatingStarsLabel(0);
    }
  };
  function getRatingLabel() {
    if (!token) {
      return "Pro hodnocen\xED \u0161ifry se pros\xEDm p\u0159ihla\u0161te";
    }
    switch (ratingStarsLabel) {
      case 1:
        return "Tohle u\u017E pros\xEDm v\xEDcekr\xE1t ne!";
      case 2:
        return "Nic moc.";
      case 3:
        return "Takov\xE1 oby\u010Dejn\xE1 \u0161ifa, nezaujme, neuraz\xED.";
      case 4:
        return "Takhle byla fajn ;)";
      case 5:
        return "Lah\u016Fdka!";
    }
    if (ratingTeamStars > 0) {
      return `Va\u0161e hodnocen\xED: ${ratingTeamStars}*`;
    } else {
      return "Zat\xEDm jste \u0161ifru nehodnotili, budeme r\xE1di za ka\u017Ed\xE9 hodnocen\xED a p\u0159\xEDpadn\xE9 koment\xE1\u0159e!";
    }
  }
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(import_jsx_runtime18.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)("div", { className: "sh-rating", children: [
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        import_Rating.default,
        {
          name: "simple-controlled",
          value: ratingStars,
          onChange: (event, newValue) => {
            onRatingChange(newValue);
          },
          className: "sh-rating__stars",
          onChangeActive: (event, newValue) => {
            onRatingHover(newValue);
          },
          readOnly: !interactive || !token,
          onClick: (event) => {
            const targetValue = event.target.getAttribute("value");
            if (targetValue) {
              onRatingChange(Number(targetValue));
            }
          }
        },
        ratingStars
      ),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("div", { className: "sh-rating__votes", children: `(${ratingVotes} hlas\u016F)` })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("div", { className: "sh-rating__label", children: interactive ? getRatingLabel() : "" })
  ] });
};

// src/components/history/Cyphers.tsx
var import_react10 = require("react");
var import_jsx_runtime19 = require("react/jsx-runtime");
var Cyphers = ({ cyphers, renderCypher, selectLabel = "\u0160ifra:" }) => {
  var _a, _b;
  const [selectedKey, setSelectedKey] = (0, import_react10.useState)();
  (0, import_react10.useEffect)(() => {
    setSelectedKey(void 0);
  }, [cyphers]);
  const options = cyphers.map((c) => ({ key: c.Id, label: `${c.Id}-${c.name}` }));
  const cypher = (_b = (_a = cyphers.find((c) => c.Id === selectedKey)) != null ? _a : cyphers.find((c) => c.Id === 0)) != null ? _b : cyphers[0];
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)("div", { className: "sh-cyphers", children: [
    /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(Select, { label: selectLabel, value: cypher == null ? void 0 : cypher.Id, onChange: setSelectedKey, options }),
    cypher ? renderCypher(cypher) : /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(import_jsx_runtime19.Fragment, {})
  ] });
};

// src/components/loginModal/LoginModal.tsx
var import_react11 = require("react");
var import_react_router_dom = require("react-router-dom");

// src/utils/generateCzechSpd.ts
var toCzechIban = (account) => {
  if (account.startsWith("CZ")) {
    return account.replace(/\s+/g, "");
  }
  const [number, bankCode] = account.split("/");
  if (!number || !bankCode) {
    throw new Error("Invalid account format");
  }
  const paddedNumber = number.padStart(16, "0");
  const bban = bankCode + paddedNumber;
  const countryCode = "CZ";
  const countryNumber = "1235";
  const checkString = bban + countryNumber + "00";
  const mod97 = (numStr) => {
    let remainder2 = 0;
    for (let i = 0; i < numStr.length; i++) {
      const digit = numStr.charCodeAt(i) - 48;
      if (digit < 0 || digit > 9) {
        throw new Error("Invalid character in numeric string for mod97");
      }
      remainder2 = (remainder2 * 10 + digit) % 97;
    }
    return remainder2;
  };
  const remainder = mod97(checkString);
  const checkDigits = (98 - remainder).toString().padStart(2, "0");
  return `${countryCode}${checkDigits}${bban}`;
};
var generateCzechSpd = ({
  accountNumber,
  amount,
  variableSymbol,
  specificSymbol,
  message,
  currency = "CZK"
}) => {
  const iban = toCzechIban(accountNumber);
  const formattedAmount = Number(amount).toFixed(2);
  const parts = [
    "SPD*1.0",
    `ACC:${iban}`,
    `AM:${formattedAmount}`,
    `CC:${currency}`
  ];
  if (message) {
    const sanitizedMessage = encodeURIComponent(
      message.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    );
    parts.push(`MSG:${sanitizedMessage}`);
  }
  if (variableSymbol) {
    parts.push(`X-VS:${variableSymbol}`);
  }
  if (specificSymbol) {
    parts.push(`X-SS:${specificSymbol}`);
  }
  return parts.join("*");
};

// src/utils/commonFunctions.ts
var import_crypto_js = require("crypto-js");
function hash(message) {
  return (0, import_crypto_js.SHA256)(message).toString(import_crypto_js.enc.Hex);
}
var notEmptyString = (s) => {
  if (!s) return false;
  if (typeof s !== "string") return false;
  return s.length > 0;
};
var isValidPhone = (p) => {
  return /^[+]?[()/0-9. -]{9,}$/.test(p);
};
var isValidEmail = (e) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(e);
};
var isValidFullName = (name) => {
  if (name.length < 3) return false;
  if (!name.includes(" ")) return false;
  return true;
};
function isValidPlayer(p, i, options = {}) {
  const { nameField = "Name", fullName = false } = options;
  const name = p[nameField] || "";
  if (fullName ? !isValidFullName(name) : !notEmptyString(name)) return false;
  if (i === 0 && (!p.Email || p.Email.length === 0)) return false;
  if (p.Email && p.Email.length > 0 && !isValidEmail(p.Email)) return false;
  return true;
}
function setCookie(cookie) {
  let cookies = getAllCookies();
  let cookieExist = false;
  cookies.forEach((c) => {
    if (c.name === cookie.name) {
      c.value = cookie.value;
      cookieExist = true;
    }
  });
  if (!cookieExist) {
    cookies.push(cookie);
  }
  saveCookies(cookies);
}
function getCookie(name) {
  var _a;
  const cookies = getAllCookies();
  return (_a = cookies.find((c) => c.name === name)) == null ? void 0 : _a.value;
}
function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
function getAllCookies() {
  const cookies = [];
  document.cookie.split(";").forEach(function(el) {
    const eqIdx = el.indexOf("=");
    if (eqIdx === -1) return;
    const name = el.substring(0, eqIdx).trim();
    const value = el.substring(eqIdx + 1);
    cookies.push({ name, value });
  });
  return cookies;
}
function saveCookies(cookies) {
  cookies.filter((c) => c.value).forEach((c) => {
    document.cookie = `${c.name}=${c.value}; path=/`;
  });
}

// ../../node_modules/react-icons/cg/index.esm.js
function CgClose(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none" }, "child": [{ "tag": "path", "attr": { "d": "M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z", "fill": "currentColor" } }] })(props);
}

// src/components/modal/Modal.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
var Modal = ({ visible, headline, children, closeClick, error }) => {
  if (!visible) return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(import_jsx_runtime20.Fragment, {});
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("div", { className: "sh-modal", children: [
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("div", { className: "sh-modal__background", onClick: closeClick }),
    /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("div", { className: "sh-modal__box", children: [
      /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("div", { className: "sh-modal__box__headline", children: [
        /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("div", { className: "sh-modal__box__headline__text", children: headline }),
        /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("div", { className: "sh-modal__box__headline__close", children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(CgClose, { size: 24, onClick: closeClick }) })
      ] }),
      error && /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("div", { className: "sh-modal__error", children: error }),
      /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("div", { className: "sh-modal__box__body", children })
    ] })
  ] });
};

// src/components/modal/ConfirmModal.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
var ConfirmModal = ({ visible, onCloseClick, headline, text, children, onConfirm, confirmText = "Potvrdit", error = "" }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Modal, { visible, headline, closeClick: onCloseClick, error, children: /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)(import_jsx_runtime21.Fragment, { children: [
    children != null ? children : text,
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Button, { onClick: onConfirm, text: confirmText })
  ] }) });
};

// src/components/loginModal/LoginModal.tsx
var import_jsx_runtime22 = require("react/jsx-runtime");
var LoginModal = ({ visible, onClose, onSuccess }) => {
  const navigate = (0, import_react_router_dom.useNavigate)();
  const [login, setLogin] = (0, import_react11.useState)("");
  const [password, setPassword] = (0, import_react11.useState)("");
  const [loginError, setLoginError] = (0, import_react11.useState)("");
  const [passwordError, setPasswordError] = (0, import_react11.useState)("");
  const [errorMessage, setErrorMessage] = (0, import_react11.useState)("");
  const [forgottenPassword, setForgottenPassword] = (0, import_react11.useState)(false);
  const [email, setEmail] = (0, import_react11.useState)("");
  const [emailError, setEmailError] = (0, import_react11.useState)("");
  const [loading, setLoading] = (0, import_react11.useState)(false);
  (0, import_react11.useEffect)(() => {
    setLoading(false);
    setLogin("");
    setLoginError("");
    setPassword("");
    setPasswordError("");
    setErrorMessage("");
    setEmail("");
    setEmailError("");
    setForgottenPassword(false);
  }, [visible]);
  const initLogin = () => {
    setLoginError("");
    setPasswordError("");
    setErrorMessage("");
    if (login.length < 1) {
      setLoginError("P\u0159ihla\u0161ovac\xED jm\xE9no mus\xED b\xFDt vypln\u011Bno!");
      return;
    }
    if (password.length < 1) {
      setPasswordError("Heslo mus\xED b\xFDt vypln\u011Bno!");
      return;
    }
    setLoading(true);
    getId({ login, password: "" }).then((id) => {
      if (!id || id === "-1") {
        setLoading(false);
        setErrorMessage("Pro zadan\xE9 jm\xE9no nebyl nalezen \u017E\xE1dn\xFD t\xFDm.");
        return;
      }
      doLogin(id);
    }).catch(() => {
      setLoading(false);
      setErrorMessage("Do\u0161lo k neo\u010Dek\xE1van\xE9 chyb\u011B, v p\u0159\xEDpad\u011B p\u0159etrvaj\xEDc\xEDch probl\xE9m\u016F kontaktujte organiz\xE1tory.");
    });
  };
  const doLogin = (id) => {
    const encryptedPswd = hash(id + password);
    loginUser({ login, password: encryptedPswd }).then((response) => {
      setLoading(false);
      if (response.token) {
        onSuccess(response.token);
        navigate("registration" /* REGISTRATION */);
        onClose();
      } else {
        setErrorMessage(response.errorMessage || "P\u0159ihl\xE1\u0161en\xED se nezda\u0159ilo. Ujist\u011Bte se, \u017Ee zad\xE1v\xE1te spr\xE1vn\xFD n\xE1zev t\xFDmu a heslo, v p\u0159\xEDpad\u011B probl\xE9m\u016F kontaktujte organiz\xE1tory.");
      }
    }).catch(() => {
      setLoading(false);
      setErrorMessage("P\u0159ihl\xE1\u0161en\xED se nezda\u0159ilo. Ujist\u011Bte se, \u017Ee zad\xE1v\xE1te spr\xE1vn\xFD n\xE1zev t\xFDmu a heslo, v p\u0159\xEDpad\u011B probl\xE9m\u016F kontaktujte organiz\xE1tory.");
    });
  };
  const sendPassword = () => {
    setLoginError("");
    setEmailError("");
    setErrorMessage("");
    if (login.length < 1) {
      setLoginError("P\u0159ihla\u0161ovac\xED jm\xE9no mus\xED b\xFDt vypln\u011Bno!");
      return;
    }
    if (email.length < 1) {
      setEmailError("Email 1. hr\xE1\u010De mus\xED b\xFDt vypln\u011Bn!");
      return;
    }
    setLoading(true);
    sendForgottenPassword({ login, email }).then((res) => {
      setLoading(false);
      if (res.success) {
        setErrorMessage("Postup k obnov\u011B hesla v\xE1m byl odesl\xE1n na email.");
      } else {
        setErrorMessage(res.errorMessage);
      }
    }).catch(() => {
      setLoading(false);
      setErrorMessage("Obnova hesla se nezda\u0159ila, kontaktujte pros\xEDm organiz\xE1tory emailem.");
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(Modal, { visible, headline: "P\u0159ihl\xE1\u0161en\xED", closeClick: onClose, error: errorMessage, children: loading ? /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(Loading, { size: 25 }) : /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)(import_jsx_runtime22.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
      Input,
      {
        label: "T\xFDm",
        required: true,
        type: "text",
        value: login,
        setValue: (e) => setLogin(e.target.value),
        errorMessage: loginError
      }
    ),
    forgottenPassword ? /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
      Input,
      {
        label: "Email 1. hr\xE1\u010De",
        required: true,
        type: "text",
        value: email,
        setValue: (e) => setEmail(e.target.value),
        errorMessage: emailError
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
      Input,
      {
        label: "Heslo",
        required: true,
        type: "password",
        value: password,
        setValue: (e) => setPassword(e.target.value),
        errorMessage: passwordError
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
      Button,
      {
        text: forgottenPassword ? "Obnovit heslo" : "P\u0159ihl\xE1sit se",
        onClick: forgottenPassword ? sendPassword : initLogin
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)("div", { className: "sh-login-modal__links", children: [
      /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)("div", { children: [
        "Je\u0161t\u011B nem\xE1te registrovan\xFD t\xFDm? Registrujte se",
        " ",
        /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("span", { className: "sh-login-modal__href", onClick: () => {
          navigate("registration" /* REGISTRATION */);
          onClose();
        }, children: "zde" }),
        "."
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("span", { className: "sh-login-modal__href", onClick: () => setForgottenPassword(!forgottenPassword), children: forgottenPassword ? "Zp\u011Bt na p\u0159ihl\xE1\u0161en\xED" : "Zapomn\u011Bli jste heslo?" }) })
    ] })
  ] }) });
};

// src/components/userModal/UserModal.tsx
var import_jsx_runtime23 = require("react/jsx-runtime");
var UserModal = ({ visible, closeClick, items, children }) => {
  if (!visible) return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_jsx_runtime23.Fragment, {});
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)("div", { className: "sh-user-modal__overlay", children: [
    /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("div", { className: "sh-user-modal__background", onClick: closeClick }),
    /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)("div", { className: "sh-user-modal__box", children: [
      items == null ? void 0 : items.map((item) => /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)("div", { className: "sh-user-modal__item", onClick: item.onClick, children: [
        item.icon ? /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("span", { className: "sh-user-modal__item__icon", children: item.icon }) : null,
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("span", { className: "sh-user-modal__item__text", children: item.text })
      ] }, item.key)),
      children
    ] })
  ] });
};

// src/components/payment/PaymentSection.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");
var PaymentSection = ({
  accountNumber,
  amount,
  variableSymbol,
  specificSymbol,
  message,
  size = 128
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("div", { className: "payment_section", children: [
    /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("ul", { children: [
      /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("li", { children: [
        "\u010C\xEDslo \xFA\u010Dtu: ",
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("strong", { children: accountNumber })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("li", { children: [
        "\u010C\xE1stka: ",
        /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("strong", { children: [
          amount,
          " K\u010D"
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("li", { children: [
        "Variabiln\xED symbol: ",
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("strong", { children: variableSymbol })
      ] }),
      specificSymbol && /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("li", { children: [
        "Specifick\xFD symbol: ",
        /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("strong", { children: specificSymbol })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("li", { children: [
        "Zpr\xE1va pro p\u0159\xEDjemce: ",
        message
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("div", { className: "payment_section__qr", children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
      QrPayment,
      {
        accountNumber,
        amount,
        variableSymbol,
        specificSymbol,
        message,
        size
      }
    ) })
  ] });
};

// src/components/qr/QrPayment.tsx
var import_qrcode = __toESM(require("qrcode.react"));
var import_jsx_runtime25 = require("react/jsx-runtime");
var QrPayment = ({
  accountNumber,
  amount,
  variableSymbol,
  specificSymbol,
  message,
  size = 128
}) => {
  const qrValue = generateCzechSpd({
    accountNumber,
    amount,
    variableSymbol,
    specificSymbol,
    message
  });
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)("div", { className: "qr-payment", children: /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(import_qrcode.default, { value: qrValue, size }) });
};

// src/components/scroll/ScrollToTop.tsx
var import_react12 = require("react");
var import_react_router_dom2 = require("react-router-dom");
var ScrollToTop = () => {
  const { pathname } = (0, import_react_router_dom2.useLocation)();
  (0, import_react12.useEffect)(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// src/components/team/Player.tsx
var import_jsx_runtime26 = require("react/jsx-runtime");
var Player = (player) => {
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)("div", { className: "sh-team__players__player", children: [
    player.FullName ? player.FullName : player.Name,
    player.Email ? ", " + player.Email : "",
    player.Age && player.Age > 1 ? ", " + player.Age + " let" : "",
    player.City ? ", " + player.City : ""
  ] }, player.Id);
};

// src/components/team/Team.tsx
var import_jsx_runtime27 = require("react/jsx-runtime");
var Team = ({ team, admin = false }) => {
  var _a, _b;
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)("div", { className: "sh-team", children: [
    /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)("div", { className: "sh-team__name", children: [
      team.Payed ? /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { className: "sh-team__name__payed", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(TbMoneybag, {}) }) : "",
      team.Name
    ] }),
    admin ? /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(import_jsx_runtime27.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)("div", { className: "sh-team__phone", children: [
        "Telefon: ",
        team.Phone
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { className: "sh-team__players", children: (_a = team.Players) == null ? void 0 : _a.map((p, i) => {
        return /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(Player, { ...p });
      }) })
    ] }) : /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { className: "sh-team__players", children: (_b = team.Players) == null ? void 0 : _b.map((p, i) => {
      return (i > 0 ? ", " : "") + (p.Name ? p.Name : "?");
    }) })
  ] }, team.Id);
};

// src/hooks/useOnClickOutside.ts
var import_react13 = require("react");
var useOnClickOutside = (ref, handler) => {
  (0, import_react13.useEffect)(() => {
    const listener = (event) => {
      var _a;
      if ((_a = ref.current) == null ? void 0 : _a.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};

// src/redux/createAppRedux.tsx
var import_react14 = require("react");
var import_toolkit = require("@reduxjs/toolkit");
var createAppRedux = (appReducer) => {
  const rootReducer = (0, import_toolkit.combineReducers)({ app: appReducer });
  const store = (0, import_toolkit.configureStore)({ reducer: rootReducer, devTools: true });
  const AppContext = (0, import_react14.createContext)({});
  return { store, AppContext };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AddNewPaymentForm,
  Button,
  CheckBox,
  ConfirmModal,
  Cypher,
  CypherRating,
  Cyphers,
  ECathegory,
  ECypherType,
  EHelpType,
  EMessageType,
  EPage,
  EUserType,
  Footer,
  ForumForm,
  ForumMessage,
  Header,
  Heading,
  Help,
  Input,
  Loading,
  LoadingPage,
  LoginModal,
  Modal,
  PaymentSection,
  Pdf,
  Player,
  QrPayment,
  ScrollToTop,
  Section,
  Select,
  Spacer,
  Team,
  UserModal,
  addPayment,
  configureApi,
  createAppRedux,
  del,
  deleteCookie,
  deletePayment,
  deletePlayerEmail,
  generateCzechSpd,
  generateNewLoginToken,
  get,
  getAdminTeams,
  getCookie,
  getCypherMessages,
  getForumMessages,
  getId,
  getStars,
  getStats,
  getTeams,
  getUser,
  getUserDetail,
  hash,
  isValidEmail,
  isValidFullName,
  isValidPhone,
  isValidPlayer,
  loginUser,
  notEmptyString,
  post,
  reUnregisterTeam,
  registerUser,
  saveForumMessage,
  saveUser,
  sendForgottenPassword,
  setCookie,
  setStars,
  unregisterTeam,
  useOnClickOutside
});
